import { useEffect, useState } from "react";

import { useLanguage } from "@/i18n/LanguageContext";
import { fetchMyConferenceContext } from "../api";
import { AuthenticatedShell, type ShellNavItem } from "./AuthenticatedShell";

export function ParticipantShell() {
  const { t } = useLanguage();
  const [reviewerOnly, setReviewerOnly] = useState(false);
  const [isReviewer, setIsReviewer] = useState(false);

  useEffect(() => {
    fetchMyConferenceContext()
      .then((ctx) => {
        setIsReviewer(Boolean(ctx.is_reviewer));
        setReviewerOnly(Boolean(ctx.is_reviewer && !ctx.has_registration));
      })
      .catch(() => {
        setIsReviewer(false);
        setReviewerOnly(false);
      });
  }, []);

  let items: ShellNavItem[];
  let homeTo: string;
  let subtitle: string;

  if (reviewerOnly) {
    items = [
      { to: "/reviews", label: t.nav.reviews, end: true },
      { to: "/account/security", label: t.nav.accountSecurity },
    ];
    homeTo = "/reviews";
    subtitle = t.nav.reviews;
  } else {
    items = [
      { to: "/dashboard", label: t.nav.dashboard, end: true },
      { to: "/dashboard#my-papers", label: t.nav.myPapers },
      { to: "/submit-paper", label: t.nav.submit },
      { to: "/schedule", label: t.nav.schedule },
      { to: "/venue", label: t.nav.venue },
    ];
    if (isReviewer) {
      items.push({ to: "/reviews", label: t.nav.reviews });
    }
    items.push({ to: "/account/security", label: t.nav.accountSecurity });
    homeTo = "/dashboard";
    subtitle = t.nav.participantWorkspace;
  }

  return (
    <AuthenticatedShell
      title={t.brandShort}
      subtitle={subtitle}
      homeTo={homeTo}
      items={items}
    />
  );
}
